/*LIBRARY*/
import { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import TextFieldGroup from "../common_input/TextFieldGroup";

/*REDUX*/
import {
  email_forget_password,
  forget_password,
  code_forget,
  whatsapp_forget_password,
} from "../../App/actions/authActions";

/*PICTURE*/

/*FUNCTION*/
import history from "../../App/actions/history";
import checkContactType from "../../App/validation/checkContactType";

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/
const countdown_value = 10; //second

const Messages = ({ color, title }) => {
  return (
    <p
      style={{
        fontSize: "0.7rem",
        color: `${color}`,
      }}
    >
      {title}
    </p>
  );
};

const ForgetPassword = ({
  auth: { loading },
  errors: propsErrors,
  email_forget_password,
  forget_password,
  code_forget,
  whatsapp_forget_password,
}) => {
  const [email_or_whatsapp, set_email_or_whatsapp] = useState("");
  const [username, set_username] = useState("");
  const [password2, set_password2] = useState("");
  const [password3, set_password3] = useState("");
  const [messageCode, set_messageCode] = useState("");
  const [notSamePassword, set_notSamePassword] = useState("");
  const [messageEmail, set_messageEmail] = useState(null);
  const [errors, set_errors] = useState({});

  // show
  const [showcode, set_showcode] = useState(false);
  const [countdown, set_countdown] = useState(false);
  const [countdownfinished, set_countdownfinished] = useState(false);
  const [changeShow, set_changeShow] = useState(false);
  const [show_password, set_show_password] = useState(false);

  // cooldown time
  const [code, set_code] = useState("");
  const [seconds, set_seconds] = useState(countdown_value);
  const intervalTime = useRef(null);

  useEffect(() => {
    if (propsErrors) {
      set_errors(propsErrors);
    }
  }, [propsErrors]);

  useEffect(() => {
    return () => {
      if (intervalTime.current) clearInterval(intervalTime.current);
    };
  }, []);

  const secondsToTime = (secs) => {
    let hours = Math.floor(secs / (60 * 60));
    let divisor_for_minutes = secs % (60 * 60);
    let minutes = Math.floor(divisor_for_minutes / 60);
    let divisor_for_seconds = divisor_for_minutes % 60;
    let seconds_val = Math.ceil(divisor_for_seconds);

    return {
      h: hours,
      m: minutes,
      s: seconds_val,
    };
  };

  const countDown = () => {
    set_seconds((prevSeconds) => {
      const nextSeconds = prevSeconds - 1;
      if (nextSeconds <= 0) {
        if (intervalTime.current) clearInterval(intervalTime.current);
        set_countdown(false);
        set_countdownfinished(true);
        return 0;
      }
      return nextSeconds;
    });
  };

  const toggleShowPassword = () => {
    set_show_password(!show_password);
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    if (id === "email_or_whatsapp") set_email_or_whatsapp(value);
    if (id === "username") set_username(value);
    if (id === "password2") set_password2(value);
    if (id === "password3") set_password3(value);
    if (id === "code") set_code(value);
  };

  const handleChangeEmailOrPhoneNumber = (e) => {
    const { value } = e.target;
    if (String(value)?.[0] === "0") {
      set_email_or_whatsapp("62" + value.slice(1));
    } else {
      set_email_or_whatsapp(value);
    }
  };

  const handleSubmitEmail = async (e) => {
    e.preventDefault();
    try {
      const type = checkContactType(email_or_whatsapp);

      if (email_or_whatsapp === "" || username === "") {
        set_messageEmail(303);
      } else {
        const lang = localStorage.getItem("language");
        let bodyLang = "en";
        if (lang === "ina") {
          bodyLang = "id";
        }

        let body = {
          username: username,
          lang: bodyLang,
        };

        let res = null;
        if (type === "email") {
          body.email = email_or_whatsapp;
          res = await email_forget_password(body);
        } else if (type === "whatsapp") {
          body.phone_number = email_or_whatsapp;
          res = await whatsapp_forget_password(body);
        }

        if (res.status === 200) {
          set_showcode(true);
          set_messageEmail(202);
          set_countdown(true);
          set_seconds(countdown_value);
          if (intervalTime.current) clearInterval(intervalTime.current);
          intervalTime.current = setInterval(countDown, 1000);
        } else {
          throw Error();
        }
      }
    } catch (error) {
      set_messageEmail(404);
    }
  };

  const handleSubmitCode = async (e) => {
    e.preventDefault();

    if (code === "") {
      set_messageCode(202);
    } else {
      const body = {
        username,
        email: email_or_whatsapp,
        code,
      };
      const res = await code_forget(body);
      if (res?.status === 200) {
        set_changeShow(!changeShow);
      } else {
        if (res?.response?.data?.error?.message)
          set_errors({ code: res?.response?.data?.error?.message });
      }
    }
  };

  const handleSubmitPassword = (e) => {
    e.preventDefault();

    if (password2 === "" || password3 === "") {
      set_notSamePassword(404);
    } else if (password2.length <= 8) {
      set_notSamePassword(505);
    } else {
      if (password2 === password3) {
        set_changeShow(!changeShow);
        const body = {
          email: email_or_whatsapp,
          username,
          password1: password2,
          password2: password3,
        };
        forget_password(body);
        history.push("/login");
      } else {
        set_notSamePassword(303);
      }
    }
  };

  const time_to_string = ({ h = 0, m = 0, s = 0 }) => {
    let min = "00";
    let sec = "00";
    let hour = "";

    if (h) {
      if (`${h}`.length === 1) {
        hour = `0${h}:`;
      } else {
        hour = `${h}:`;
      }
    }

    if (`${m}`.length === 1) {
      min = `0${m}`;
    } else {
      min = `${m}`;
    }

    if (`${s}`.length === 1) {
      sec = `0${s}`;
    } else {
      sec = `${s}`;
    }

    return `${hour}${min}:${sec}`;
  };

  const language = localStorage?.language ? localStorage?.language : "ina";
  const count_down_text = time_to_string(secondsToTime(seconds));

  let item_content = (
    <div>
      {changeShow ? (
        <div>
          <form>
            <TextFieldGroup
              type={show_password ? "text" : "password"}
              isPassword={true}
              placeholder={dict["Password"][language]}
              name="password2"
              id="password2"
              value={password2}
              onChange={handleChange}
              error={errors.password2}
              toggleShowPassword={toggleShowPassword}
              pattern="[0-9a-zA-Z]{8,}"
            />
            <TextFieldGroup
              placeholder={dict["Confirm password"][language]}
              type={show_password ? "text" : "password"}
              isPassword={true}
              name="password3"
              id="password3"
              value={password3}
              onChange={handleChange}
              error={errors.password3}
              toggleShowPassword={toggleShowPassword}
              pattern="[0-9a-zA-Z]{8,}"
            />
            <section className="marginTop_10">
              {notSamePassword === 303 ? (
                <Messages
                  color="#ff0000"
                  title={dict["Password not the same"][language]}
                />
              ) : notSamePassword === 404 ? (
                <Messages
                  color="#ff0000"
                  title={dict["Please input password"][language]}
                />
              ) : notSamePassword === 505 ? (
                <Messages
                  color="#ff0000"
                  title={dict["Minimum 8 characters"][language]}
                />
              ) : null}
            </section>

            {loading ? (
              <button className="button background_black" type="submit">
                {dict["Sending ......"][language]}
              </button>
            ) : (
              <button
                className="button background_black"
                type="submit"
                onClick={handleSubmitPassword}
              >
                Reset Password
              </button>
            )}
          </form>
        </div>
      ) : (
        <>
          {countdown ? (
            <>
              <TextFieldGroup
                placeholder={dict["Username"][language]}
                type="username"
                name="username"
                id="username"
                value={username}
                onChange={handleChange}
                error={errors.username}
                disabled
              />
              <TextFieldGroup
                placeholder={dict["Email"][language]}
                type={"text"}
                name={"email_or_whatsapp"}
                id={"email_or_whatsapp"}
                value={email_or_whatsapp}
                onChange={handleChange}
                error={errors.email_or_whatsapp}
                disabled
              />
              <section className="marginTop_10">
                {messageEmail === 202 ? (
                  <Messages
                    color="#008000"
                    title={dict["Code verification"][language]}
                  />
                ) : messageEmail === 303 ? (
                  <Messages
                    color="#ff0000"
                    title={
                      dict["Please input your username or email"][language]
                    }
                  />
                ) : messageEmail === 404 ? (
                  <Messages
                    color="#ff0000"
                    title={dict["Email not found"][language]}
                  />
                ) : null}
              </section>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <p style={{ fontSize: "15px" }}>{count_down_text}</p>
              </div>
            </>
          ) : (
            <>
              <TextFieldGroup
                placeholder={dict["Username"][language]}
                type="username"
                name="username"
                id="username"
                value={username}
                onChange={handleChange}
                error={errors.username}
              />
              <TextFieldGroup
                placeholder={"Email/Whatsapp"}
                type={"email_or_whatsapp"}
                name={"email_or_whatsapp"}
                id={"email_or_whatsapp"}
                value={email_or_whatsapp}
                onChange={handleChangeEmailOrPhoneNumber}
                error={errors.email_or_whatsapp}
              />
              <section className="marginTop_10">
                {messageEmail === 202 ? (
                  <Messages
                    color="#008000"
                    title={dict["Code verification"][language]}
                  />
                ) : messageEmail === 303 ? (
                  <Messages
                    color="#ff0000"
                    title={
                      dict["Please input your username or email"][language]
                    }
                  />
                ) : messageEmail === 404 ? (
                  <Messages
                    color="#ff0000"
                    title={dict["Email not found"][language]}
                  />
                ) : null}
              </section>
              <div
                style={{
                  marginTop: "10px",
                  marginBottom: "10px",
                  display: "flex",
                  justifyContent: countdownfinished ? "flex-start" : "flex-end",
                }}
              >
                {loading ? (
                  <button className="button background_black" type="submit">
                    {dict["Sending ......"][language]}
                  </button>
                ) : (
                  <>
                    {!countdown && countdownfinished ? (
                      <div>
                        <label
                          style={{
                            color: "grey",
                          }}
                        >
                          {dict["Didn't get the code yet?"][language]}
                        </label>
                        <button
                          onClick={handleSubmitEmail}
                          className="button background_black"
                        >
                          {dict["Resend Code"][language]}
                        </button>
                      </div>
                    ) : (
                      <button
                        className="marginTop_20 button_inactive rounded_5 bg_black text_white w_full h_50"
                        type="submit"
                        onClick={handleSubmitEmail}
                        data-mapid="clickSend"
                      >
                        {dict["Send"][language]}
                      </button>
                    )}
                  </>
                )}
              </div>
            </>
          )}
          {showcode && (
            <div>
              <section
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <TextFieldGroup
                  placeholder={dict["Code"][language]}
                  name="code"
                  id="code"
                  value={code}
                  onChange={handleChange}
                  error={errors.code}
                />
              </section>
              <section>
                <button
                  className="marginTop_20 button_inactive rounded_5 bg_black text_white w_full h_50"
                  type="submit"
                  onClick={handleSubmitCode}
                >
                  {dict["Submit"][language]}
                </button>
              </section>
              <section>
                {messageCode === 202 ? (
                  <Messages
                    color="#ff0000"
                    title={dict["please input your code"][language]}
                  />
                ) : messageCode === 303 ? (
                  <Messages
                    color="#ff0000"
                    title={dict["Code not match"][language]}
                  />
                ) : null}
              </section>
            </div>
          )}
        </>
      )}
    </div>
  );
  return <main>{item_content}</main>;
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors,
});

export default connect(mapStateToProps, {
  email_forget_password,
  forget_password,
  code_forget,
  whatsapp_forget_password,
})(ForgetPassword);
